import { useTranslation } from "react-i18next";
import { Input } from "antd";
import { OffsiteCampaignContextType } from "context/OffsiteCampaignProvider";
import { REDIRECT_URL_REGEX } from "utils/constants";
import RetailFormInfo from "components/Form/RetailFormInfo";
import RetailFormInput from "components/Form/RetailFormInput";
import RetailFormRow from "components/Form/RetailFormRow";
import cc from "classcat";
import cm from "./style.module.scss";

interface OffsiteRedirectUrlProps {
  formFields: OffsiteCampaignContextType["formFields"];
  handleFormFieldsChange: (
    key: keyof OffsiteCampaignContextType["formFields"],
    value: string
  ) => void;
}

const OffsiteRedirectUrl = ({
  formFields,
  handleFormFieldsChange,
}: OffsiteRedirectUrlProps) => {
  const { t } = useTranslation();

  return (
    <RetailFormRow className="form-row">
      <RetailFormInfo
        column={{
          number: "3",
          title: t("components.offsiteCampaignForm.firstStep.urlTitle"),
          text: t("components.offsiteCampaignForm.firstStep.urlText"),
        }}
      />

      <RetailFormInput
        isFocused={formFields.redirectUrl !== ""}
        name="url"
        label={t("components.offsiteCampaignForm.firstStep.urlTitle")}
        rules={[
          {
            required: true,
            message: t("components.offsiteCampaignForm.firstStep.urlError"),
            pattern: REDIRECT_URL_REGEX,
          },
        ]}
        className="floating"
      >
        <Input.TextArea
          className={cc(["floating", cm.textarea])}
          onChange={(e) =>
            handleFormFieldsChange("redirectUrl", e.target.value)
          }
          name="redirect_url"
        />
      </RetailFormInput>
    </RetailFormRow>
  );
};

export default OffsiteRedirectUrl;
